import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import {ReportSectionHeader} from "../SectionHeader";


const AdverseCorporateEventsComponent = (props) => (

    <div>
        <ReportSectionHeader>
			{"Embedded Rule 10b-5 Risk (Present Day)"}
        	
        </ReportSectionHeader>
        <ReportTable
            settings={[
                {
                    header: 'Trading Day',
                    accessor: 'date'
                },
                {
                    header: 'Adverse Corporate Event (ACE) Type',
                    accessor: 'statTypeNum',
                    statType: true,
                    centerRightJustified: true
                },
                {
                    header: 'Actual Stock Price Decline ($)',
                    accessor: 'stockPriceCh',
                    dollarValue: true,
                    round2Decimals: true,
                    centerRightJustified: true
                },
                {
                    header: 'Actual Stock Price Decline (%)', 
                    accessor: 'stockPricePch',
                    percentageNumber:true,
                    percentageSign: true,
                    centerRightJustified: true
                },
                {
                    header: 'Max. Potential Damages per Share',
                    accessor: 'dollarResidual',
                    dollarValue: true,
                    round2Decimals: true,
                    centerRightJustified: true
                }
            ] 
           }
            data={props.adverseCorporateEvents}
            name={"adverseCorporateEvents"}
            accumulator={"dollarResidual"}
            accumulatorDisplay={"Total Max. Damages Per Share"}
        />

    </div>
);


export default AdverseCorporateEventsComponent;


// WEBPACK FOOTER //
// ./src/common/components/AdverseCorporateEvents/AdverseCorporateEventsComponent.js